import { getMetaDataServiceUrl } from 'js/crossword/sdk/getMetaDataServiceUrl';
import { createDate } from './helpers/dateHelpers';

declare const sgSettings: any;

export interface IMonthInfo {
  month: number;
  dates: string[];
}

export interface IYearDateInfo {
  year: number;
  months: IMonthInfo[];
}

let cachedYearsInfo: IYearDateInfo[] | null = null;

export interface IMonthListItem {
  year: number;
  month: number;
  availableDates: string[];
}

export async function getMonthsList(): Promise<IMonthListItem[]> {
  const yearsInfo = await getYearsInfo();
  const result: IMonthListItem[] = [];
  yearsInfo.forEach(({ year, months }) => {
    months.forEach((monthInfo) => {
      result.push({
        year,
        month: monthInfo.month,
        availableDates: monthInfo.dates,
      });
    });
  });

  return result;
}

export async function getYearsInfo(): Promise<IYearDateInfo[]> {
  if (cachedYearsInfo !== null) {
    return cachedYearsInfo;
  }

  const result: IYearDateInfo[] = [];
  const dates = await fetchAllDatesRaw();

  dates
    .filter((dateString) => {
      return createDate(dateString).getTime() < Date.now();
    })
    .forEach((dateString) => {
      const date = createDate(dateString);
      const yearInfo = getOrCreateIYearDateInfo(result, date.getFullYear());
      const monthInfo = getOrCreateMonthInfo(yearInfo, date.getMonth());
      monthInfo.dates.push(dateString);
    });

  result.forEach((yearInfo) => yearInfo.months.sort((a, b) => a.month - b.month));
  result.sort((a, b) => a.year - b.year);

  cachedYearsInfo = result;

  return result;
}

function getOrCreateMonthInfo(data: IYearDateInfo, month: number): IMonthInfo {
  const existing = data.months.find((value) => value.month === month);
  if (existing) return existing;

  const newMonthInfo: IMonthInfo = { month, dates: [] };
  data.months.push(newMonthInfo);
  return newMonthInfo;
}

function getOrCreateIYearDateInfo(data: IYearDateInfo[], year: number): IYearDateInfo {
  const existing = data.find((value) => value.year === year);
  if (existing) return existing;

  const newInfo: IYearDateInfo = { year, months: [] };
  data.push(newInfo);
  return newInfo;
}

export async function fetchAllDatesRaw(): Promise<string[]> {
  return new Promise((resolve) => {
    const req = new XMLHttpRequest();
    req.open('GET', `${getMetaDataServiceUrl()}/feed/${getFeedSlug()}/alldates`, true);
    req.addEventListener('load', () => resolve(JSON.parse(req.responseText)));
    req.send();
  });
}

export function getFeedSlug(): string {
  return sgSettings.config.crossword.feedSlug;
}
